module.exports = __webpack_public_path__ + "files/a985ad72552ad069537d6eea81e719c7.json";